module.exports = __webpack_public_path__ + "img/bg_festa4.7edb2ef1.jpg";